import React from 'react'

import './loader.css'

function Loader({img}) {
  return (
    <div className='loader-svg'>
        <img src={img} alt='loader'/>
    </div>
  )
}

export default Loader